module.exports = "<div class=\"flow-container\">\r\n  <!--<h2>Flow</h2>-->\r\n  <div class=\"flow-inner-container\">\r\n    <div class=\"tree-view\">\r\n      <ul kendo-tree-view k-options=\"vm.treeViewOptions\" id=\"flow-tree-view\">\r\n      </ul>\r\n    </div>\r\n    <div class=\"graph-container\">\r\n      <h2 class=\"header\">{{vm.header}}</h2>\r\n      <div id=\"graph\" class=\"graph\"></div>\r\n    </div>\r\n  </div>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/containers/flow/flow.html
 ** module id = 894
 ** module chunks = 0
 **/